import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppState } from '@/hooks';
import { ROUTES } from '@/models/router.model';
import { selectIsAuthorized } from '@/modules/Auth';

const useAuthorizedRedirect = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const isAuthorized = useAppState(selectIsAuthorized);

  /** Страница, с которой пользователя увёл ProtectedRoute — после логина возвращаем на неё */
  const redirectPath = (state as { from?: { pathname: string; search: string } })?.from;

  useEffect(() => {
    if (isAuthorized) {
      navigate(redirectPath ? `${redirectPath.pathname}${redirectPath.search ?? ''}` : ROUTES.HOME, { replace: true });
    }
  }, [isAuthorized]);
};

export default useAuthorizedRedirect;
